import React, { Component } from 'react'

import './Offline.css'

class Offline extends Component {

    render() {

        return (

            <div className="offline">
                You appear to be offline
            </div>

        );
    }
}


export default Offline;